import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)

createSentry(app)
app.mount('#app')
